import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
    ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, List
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

/**
 * A single, smart component that can render either a simple navigation link
 * or a collapsible menu with sub-items.
 *
 * @param {object} item - The configuration object for this menu item.
 */
const MenuItem = ({ item }) => {
    const { icon, text, to, subItems } = item;
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);


    useEffect(() => {
        if (subItems) {
            const isCurrent = subItems.some(sub => location.pathname.startsWith(sub.to));
            if (isCurrent) {
                setIsOpen(true);
            }
        }
    }, [location.pathname, subItems]);

    if (subItems) {
        return (
            <>
                <ListItemButton onClick={() => setIsOpen(!isOpen)}>
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText primary={text} />
                    {isOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {subItems.map(subItem => (
                            <ListItemButton key={subItem.text} component={NavLink} to={subItem.to} sx={{ pl: 4 }}>
                                <ListItemIcon>{subItem.icon}</ListItemIcon>
                                <ListItemText primary={subItem.text} />
                            </ListItemButton>
                        ))}
                    </List>
                </Collapse>
            </>
        );
    }

    return (
        <ListItem disablePadding>
            <ListItemButton component={NavLink} to={to}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} />
            </ListItemButton>
        </ListItem>
    );
};

export default MenuItem;